module.exports = __webpack_public_path__ + "static/media/gift-points-icon.1bf7ba9d.svg";